import React from "react";
import { Typography } from "@material-ui/core";

export const DriverApp = () => (
  <div style={{ padding: 24 }}>
    <Typography variant="h5">Driver App — coming soon</Typography>
  </div>
);
